export default {
    props: ['meta', 'totalProductCount'],

    computed: {
        showCount() {
            // Does meta exist?
            return !!this.meta;
        },

        offset: function() { // eslint-disable-line
            return (this.meta.current_page - 1) * this.meta.per_page;
        },

        amount: function() { // eslint-disable-line
            return this.offset + this.meta.count;
        },
    },

    template: `
        <div v-if="showCount">
            <p>{{ totalProductCount }} products from {{ meta.total }} manufacturers, showing manufacturers {{ offset + 1 }} - {{ amount }}</p>
        </div>
    `,
};
